(function () {
  var DATA_URL_BASE = "/search?view=rf-rollenfinder-json&type=product&q=*";
  var DATA_TIMEOUT_MS = 12000;

  var cachedRows = null;
  var loadingPromise = null;

  function norm(v) {
    if (v === null || v === undefined) return "";
    return String(v).replace(/\s+/g, " ").trim();
  }

  function uniqueSorted(arr) {
    var out = [];
    var seen = Object.create(null);
    for (var i = 0; i < arr.length; i++) {
      var v = norm(arr[i]);
      if (!v) continue;
      if (!seen[v]) {
        seen[v] = 1;
        out.push(v);
      }
    }
    out.sort(function (a, b) {
      return String(a).localeCompare(String(b), "de", { sensitivity: "base" });
    });
    return out;
  }

  function fetchWithTimeout(url, ms) {
    return Promise.race([
      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } }),
      new Promise(function (_, reject) {
        setTimeout(function () {
          reject(new Error("RF timeout " + ms + "ms"));
        }, ms);
      }),
    ]);
  }

  function fetchPage(page) {
    var url = DATA_URL_BASE + "&page=" + encodeURIComponent(page);
    return fetchWithTimeout(url, DATA_TIMEOUT_MS)
      .then(function (r) { return r.text(); })
      .then(function (txt) { return JSON.parse(txt); });
  }

  function loadAllRowsOnce() {
    if (cachedRows && cachedRows.length) return Promise.resolve(cachedRows);
    if (loadingPromise) return loadingPromise;

    loadingPromise = (function () {
      var rows = [];
      var page = 1;

      function loop() {
        return fetchPage(page).then(function (res) {
          if (res && Array.isArray(res.items)) rows = rows.concat(res.items);
          if (res && res.has_next) {
            page += 1;
            if (page > 300) throw new Error("RF safety stop (>300 pages)");
            return loop();
          }
          return rows;
        });
      }

      return loop().then(function (all) {
        cachedRows = all || [];
        return cachedRows;
      });
    })();

    return loadingPromise;
  }

  function fillManufacturers(selectEl, rows) {
    var manufacturers = uniqueSorted(
      rows.map(function (r) { return r && r.manufacturer; })
    );

    // Placeholder + count (für Debug/Transparenz)
    selectEl.innerHTML = "";
    var o0 = document.createElement("option");
    o0.value = "";
    o0.textContent = "Hersteller wählen";
    selectEl.appendChild(o0);

    for (var i = 0; i < manufacturers.length; i++) {
      var opt = document.createElement("option");
      opt.value = manufacturers[i];
      opt.textContent = manufacturers[i];
      selectEl.appendChild(opt);
    }

    return manufacturers.length;
  }

  function fillDevices(deviceSel, rows, manufacturer) {
    var devices = uniqueSorted(
      rows
        .filter(function (r) { return r && norm(r.manufacturer) === manufacturer; })
        .map(function (r) { return r && r.device; })
    );

    deviceSel.innerHTML = "";
    var o0 = document.createElement("option");
    o0.value = "";
    o0.textContent = "Gerät wählen";
    deviceSel.appendChild(o0);

    for (var i = 0; i < devices.length; i++) {
      var opt = document.createElement("option");
      opt.value = devices[i];
      opt.textContent = devices[i];
      deviceSel.appendChild(opt);
    }

    deviceSel.disabled = false;
  }

  function findMatch(rows, manufacturer, device) {
    for (var i = 0; i < rows.length; i++) {
      var r = rows[i];
      if (!r) continue;
      if (norm(r.manufacturer) === manufacturer && norm(r.device) === device) return r;
    }
    return null;
  }

  function redirect(match) {
    var params = new URLSearchParams();
    params.set("type", "product");
    params.set("q", "*");
    params.append("filter.p.m.custom.breite", String(match.width));
    params.append("filter.p.m.custom.durchmesser", String(match.diameter));

    if (match.extra_handles && match.extra_handles.length) {
      params.append("rf_extra", match.extra_handles.join(","));
    }

    window.location.href = "/search?" + params.toString();
  }

  function initContainer(container, rows) {
    if (!container) return;

    var manufacturerSel = container.querySelector(".rf-narrow__manufacturer");
    var deviceSel = container.querySelector(".rf-narrow__device");
    if (!manufacturerSel || !deviceSel) return;

    // Mehrfach-Bindung verhindern (aber trotzdem späteres Refill erlauben)
    if (!container.dataset.rfBound) {
      container.dataset.rfBound = "1";

      manufacturerSel.addEventListener("change", function () {
        var m = norm(manufacturerSel.value);
        deviceSel.disabled = true;
        deviceSel.innerHTML = '<option value="">Gerät wählen</option>';
        if (!m) return;
        fillDevices(deviceSel, rows, m);
      });

      deviceSel.addEventListener("change", function () {
        var m = norm(manufacturerSel.value);
        var d = norm(deviceSel.value);
        if (!m || !d) return;
        var match = findMatch(rows, m, d);
        if (!match) return;
        redirect(match);
      });
    }

    // Initial füllen (oder wieder füllen nach Theme-Rerender)
    var count = fillManufacturers(manufacturerSel, rows);
    deviceSel.disabled = true;
    deviceSel.innerHTML = '<option value="">Gerät wählen</option>';

    // Wenn Horizon den Select nachträglich wieder „leert“ → automatisch erneut befüllen
    // (MutationObserver auf den Select + Container)
    if (!container.dataset.rfObserved) {
      container.dataset.rfObserved = "1";

      var refilling = false;

      function maybeRefill() {
        if (refilling) return;
        // Wenn nur Placeholder vorhanden ist, Theme hat geresettet
        if (!manufacturerSel || manufacturerSel.options.length <= 1) {
          refilling = true;
          // kleinen Delay, damit Theme-Morphing fertig ist
          setTimeout(function () {
            // Elemente können ersetzt worden sein → neu greifen
            manufacturerSel = container.querySelector(".rf-narrow__manufacturer");
            deviceSel = container.querySelector(".rf-narrow__device");
            if (manufacturerSel && deviceSel) {
              fillManufacturers(manufacturerSel, rows);
              deviceSel.disabled = true;
              deviceSel.innerHTML = '<option value="">Gerät wählen</option>';
            }
            refilling = false;
          }, 50);
        }
      }

      var obs = new MutationObserver(function () {
        maybeRefill();
      });

      obs.observe(container, { childList: true, subtree: true });

      // Zusätzlich: ein paar Retries nach Load (falls Theme erst später morpht)
      var retries = 0;
      var iv = setInterval(function () {
        retries += 1;
        maybeRefill();
        if (retries >= 20) clearInterval(iv); // ~5 Sekunden
      }, 250);
    }

    // Optional: Debug in DOM
    // container.dataset.rfManufacturers = String(count);
  }

  function initAll() {
    var containers = document.querySelectorAll('[data-rf="rollenfinder"]');
    if (!containers || !containers.length) return;

    loadAllRowsOnce()
      .then(function (rows) {
        if (!rows || !rows.length) throw new Error("RF: no rows loaded");
        for (var i = 0; i < containers.length; i++) {
          initContainer(containers[i], rows);
        }
      })
      .catch(function (err) {
        console.error("[RF] init failed:", err);
        for (var i = 0; i < containers.length; i++) {
          var m = containers[i].querySelector(".rf-narrow__manufacturer");
          var d = containers[i].querySelector(".rf-narrow__device");
          if (m) m.innerHTML = '<option value="">Keine Daten</option>';
          if (d) { d.innerHTML = '<option value="">Keine Daten</option>'; d.disabled = true; }
        }
      });
  }

  // Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Theme editor / section re-render
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:section:reorder", initAll);
  document.addEventListener("shopify:section:select", initAll);
})();
